<!--首页-->
<template>
  <div class="goods-video">
<!--    <video :src="video"></video>-->
    <video width="100%" controls ref="videos">
      <source :src="url">
    </video>
  </div>
</template>
<style scoped>
  .goods-video video {
    width: 100%;
  }
</style>

<script>

  export default {
    name: 'GoodsVideo',
    components: {
    },
    data: function () {
      return {
        video: [],
        url: ''
      }
    },
    filter: {},
    activated() {
    },
    mounted() {
      document.title = '商品视频';
      this.getGoodsVideo()
    },
    destroyed() {
    },
    methods: {
      getGoodsVideo() {
        let that = this,
            id= that.$route.query.id;
        this.$api.get('/api/goods/getGoodsVideo', {id: id}, (res) => {
          // that.video = res.data
          that.$refs.videos.src = res.data
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// GoodsVideo.vue?31cdcfa2